<template>
  <van-popup v-model="visible" :close-on-click-overlay="false" :lock-scroll="true">
    <div
      class="content-container"
      :style="containerStyle ? containerStyle : ''"
    >
      <div v-if="titleFormatter" class="title">
        <span v-html="titleFormatter" />
        <img
          v-if="closeIcon"
          class="icon-close"
          src="../../assets/icon_close.png"
          @click.stop="hide"
        >
      </div>
      <div
        v-if="contentFormatter"
        class="content"
        :style="contentStyle ? contentStyle : ''"
        v-html="contentFormatter"
      />
      <slot name="content"/>
      <!--一个按钮时-->
      <div v-if="btn || btnGroup.length === 1" class="btn" @click.stop="handleClick">{{ btn || btnGroup[0] }}</div>
      <!--按钮为数组且有两项时-->
      <div v-if="btnGroup.length > 1" class="btn-group">
        <div class="btn-item" @click.stop="handleClick">{{ btnGroup[0] }}</div>
        <div class="btn-item" @click.stop="handleButtonClick">{{ btnGroup[1] }}</div>
      </div>
      <slot name="btn"/>
    </div>
  </van-popup>
</template>

<script>
import popupFade from '@/components/popup/fade.vue';

export default {
  name: 'Modal',
  components: {
    popupFade
  },
  data() {
    return {
      visible: false,
      title: '',
      btn: '',
      btnGroup: [],
      content: '',
      contentStyle: '',
      containerStyle: '',
      closeIcon: false,
      maskClick: false,
      onClick: () => {},
      buttonClick: () => {}
    };
  },
  computed: {
    titleFormatter () {
      if (this.title) {
        return this.title.replace(/\n/g, '<br />')
      }
      return ''
    },
    contentFormatter () {
      if (!this.content) return '';
      return this.content.replace(/\n/g, '<br/>');
    }
  },
  methods: {
    hide() {
      this.visible = false;
    },
    handleClick() {
      this.onClick && this.onClick();
    },
    // 按钮组中的右侧按钮
    handleButtonClick () {
      this.buttonClick && this.buttonClick();
    },
    maskClickHandle() {
      this.visible = false;
      this.$emit('onClose');
    }
  }
};
</script>

<style lang="scss" scoped>
.van-popup {
  border-radius: 40px;
  padding: 32px 48px 50px;
}

.content-container {
  width: 494px;
  max-height: 958px;
  background: #FFFFFF;
  border-radius: 40px;

  .icon-close {
    position: absolute;
    right: 0px;
    top: -5px;
    width: 48px;
  }

  .content {
    font-size: 32px;
    font-weight: 400;
    line-height: 44px;
    text-align: center;
    max-height: 830px;
    overflow-y: auto;
    word-wrap: break-word;
    font-size: 28px;
    font-weight: 400;
    color: #111111;
    line-height: 40px;

  }

  .title {
    font-size: 32px;
    font-weight: 550;
    color: #111;
    line-height: 56px;
    text-align: center;
    position: relative;
    padding-bottom: 32px;
    border-bottom: none
  }
}

.btn {
  height: 90px;
  background: #FF6A39;
  border-radius: 45px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 32px;
  font-weight: 550;
  color: #ffffff;
  line-height: 44px;
  margin-top: 32px;
}
.btn-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .btn-item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70px;
    font-size: 24px;
    padding: 0 32px;
    border: 1px solid #cfcfcf;
    border-radius: 20px;
    background: #ffffff;
    color: #868686;
    white-space: nowrap;
    &:first-child {
      width: 198px;
      color: #868686;
    }
    &:last-child {
      width: 320px;
      background: #ff6a39;
      color: #ffffff;
      margin-left: 24px;
      border: none;
    }
    & .single-btn {
      width: 100%;
      color: #868686;
    }
  }
}
</style>
